import { useTranslation } from 'react-i18next'

import { getDateFnsLocale } from '@app/helpers'

import { Calendar } from '@lib/components'

import { isValidDate } from './helpers'
import styles from './styles.module.scss'

import { TourTimeProps } from './types'
import { useTourInfo } from './useTourInfo'

export const TourInfo = ({ date, tourTime, location }: TourTimeProps) => {
  const { t, i18n } = useTranslation()
  const locale = getDateFnsLocale(i18n.language)
  const { tourTimeFormatted, listingAddressLine1, listingAddressLine2 } =
    useTourInfo(tourTime, location, locale)
  const formattedTime = tourTimeFormatted || t('Chat.Inbox.Tour.AnyTimeslot')

  return (
    <div className={styles.tourInfo}>
      {date && isValidDate(date) && <Calendar date={new Date(date)} />}
      <div className={styles.tourDetails}>
        <div className={styles.timeLabel}>
          {(!isValidDate(date) && (
            <>
              {t('Chat.Inbox.Tour.AsSoonAsPossible')} - {formattedTime}
            </>
          )) || <>{formattedTime}</>}
        </div>
        {listingAddressLine1 && (
          <div className={styles.addressLine}>{listingAddressLine1}</div>
        )}
        {listingAddressLine2 && listingAddressLine2.length > 0 && (
          <div className={styles.addressLine}>{listingAddressLine2}</div>
        )}
      </div>
    </div>
  )
}
